import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl,
  DVFormArray
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import _ from 'lodash';
import moment from 'moment';
import { ExperiencesService } from '../experiences.service';

@Component({
  selector: 'app-add-experience',
  templateUrl: './add-experience.component.html',
  styleUrls: ['./add-experience.component.css']
})
export class AddExperienceComponent implements OnInit {
  experienceForm: DVFormGroup;
  isAddState = true;
  excludedItems: Array<String> = [];
  constructor(
    public route: ActivatedRoute,
    private experienceApi: ExperiencesService,
    private notifier: SnotifyService,
    private router: Router
  ) {
    this.experienceForm = new DVFormGroup({
      id: new DVFormControl(null),
      slug: new DVFormControl(null, {
        'slug is required': Validators.required
      }),
      name: new DVFormControl(null, {
        'name is required': Validators.required
      }),
      tagline: new DVFormControl(),
      discount: new DVFormControl(),
      videoUrl: new DVFormControl('', {
        // tslint:disable-next-line: max-line-length
        'This link is not valid': Validators.pattern('(https?://)?(www\\.)?(yotu\\.be/|youtube\\.com/)?((.+/)?(watch(\\?v=|.+&v=))?(v=)?)([\\w_-]{11})(&.+)?')
      }),
      relatedExperienceIds: new DVFormControl([]),
      description: new DVFormControl(),
      highlights: new DVFormControl(),
      included: new DVFormControl([], {
        'Included is required': Validators.required
      }),
      excluded: new DVFormControl([], {
        'Excluded is required': Validators.required
      }),
      facts: new DVFormControl([]),
      duration: new DVFormControl(0, {
        'Duration cannot be less than 1 day': Validators.min(0),
        'Duration cannot be more than 10 days': Validators.max(10)
      }),
      maximumCapacity: new DVFormControl(),
      countryId: new DVFormControl(),
      cityId: new DVFormControl(),
      tags: new DVFormControl(),
      metaKeywords: new DVFormControl(null),
      metaDescription: new DVFormControl(null),
      metaTitle: new DVFormControl(null),
      experienceTypes: new DVFormControl(null),

      startIndex: new DVFormControl(null),
      startDate: new DVFormControl(),
      endDate: new DVFormControl(),
      ExperienceCancellationPolicies: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'days',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'percentage',
            type: 'CONTROL',
            default: null,
          }
        ],
        0,
        {
          'Cancellation Policies': Validators.required
        }
      ),
      Price: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null
          },
          {
            name: 'from',
            type: 'CONTROL',
            default: 0,
            validators: {
              'Number of travelers': Validators.nullValidator
            }
          },
          {
            name: 'to',
            type: 'CONTROL',
            default: 1,
          },
          {
            name: 'amount',
            type: 'CONTROL',
            default: 0,
          }
        ],
        0,
        {
          'Prices': Validators.required
        }
      ),
      Location: new DVFormControl(null),
      ExperienceDays: new DVFormArray([]),
      ExperiencePictures: new DVFormControl([], {
        'Experience Pictures is required': Validators.required
      }),
      active: new DVFormControl()
    });
  }

  ngOnInit() {
    this.route.url.subscribe((url) => {
      if (
        url.toString().includes('edit') &&
        this.route.snapshot.params.id
      ) {
        this.isAddState = false;
        this.initiateEditMode();
      } else {
        this.isAddState = true;
      }
    });
  }

  formSubmit(active?: boolean) {
    console.log(this.experienceForm.valid , ">>>>>>>>>");
    if (this.experienceForm.valid) {
      const formResult = this.experienceForm.getCleanValue();
      // this.excludedItems = null;
      if (formResult.excluded) {
        for (let exc of formResult.excluded) {
          this.excludedItems.push( exc );
        }
        formResult.excluded =  this.excludedItems.toString();
      } else {
        formResult.excluded = '';
      }

      if (formResult.tags) {
        formResult.tags = formResult.tags.map(tag => tag.id);
      }
      formResult.relatedExperienceIds = formResult.relatedExperienceIds ? formResult.relatedExperienceIds.map(exp => exp.value) : [];
      if (formResult.experienceTypes) {
        formResult.experienceTypes = formResult.experienceTypes.map(type => type.id);
      }
      if (formResult.ExperienceDays) {
          formResult.ExperienceDays = formResult.ExperienceDays.map((day, index) => (
          {
            id: day.id,
            order: index + 1,
            title: day.title,
            description: day.description,
            settings: {
              meals: day.meals,
              overnight: day.overnight
            },
            Activities: (day.Activities ? day.Activities.map((activity, ind) => ({
              ...activity
              , order: ind + 1
            })) : '' )
          }));
      }
      formResult.tagline = formResult.tagline ? formResult.tagline : null;
      formResult.videoUrl = formResult.videoUrl ? formResult.videoUrl : null;
      formResult.metaKeywords = formResult.metaKeywords ? formResult.metaKeywords : null;
      formResult.metaDescription = formResult.metaDescription ? formResult.metaDescription : null;
      formResult.metaTitle = formResult.metaTitle ? formResult.metaTitle : null;

      if (this.isAddState) {
        this.performAddOperation(formResult, active);
      } else {
        this.performEditOperation(formResult, formResult.id);
      }
    } else {
      this.experienceForm.forceShowErrors();
    }
  }


  private initiateEditMode() {
    const included = [];
    const excluded = [];
    const experienceId = this.route.snapshot.params.id;
    this.experienceApi.getSingleExperienceById(experienceId).subscribe(response => {
      const experienceBody = response.data.experience;
      experienceBody.experienceTypes = experienceBody.ExperienceTypes;
      experienceBody.countryId = (experienceBody.City ? experienceBody.City.countryId : '');
      experienceBody.tags = experienceBody.Tags;
      experienceBody.startDate = (experienceBody.startDate ? moment(experienceBody.startDate).format('YYYY-MM-DD') : '');
      experienceBody.endDate = (experienceBody.endDate ? moment(experienceBody.endDate).format('YYYY-MM-DD') : '');

      experienceBody.included.map(a => {
        included.push(JSON.parse(a));
      });
      experienceBody.included = included;
      experienceBody.excluded = experienceBody.excluded ? experienceBody.excluded.split(',') : '';
      experienceBody.relatedExperienceIds = experienceBody.RelatedExperiences.map((exp: any) => {
        return {
          value: exp.id,
          display: exp.name
        };
      });
      experienceBody.ExperienceDays = experienceBody.ExperienceDays.map((day, index) => ({
        id: day.id,
        order: index + 1,
        title: day.title,
        description: day.description,
        meals: day.settings.meals,
        overnight: day.settings.overnight,
        Activities: day.Activities
      }));
      this.experienceForm.patchValue(experienceBody);
    });
  }

  private performAddOperation(experienceFormBody, active) {
    experienceFormBody = {
      active,
      ...experienceFormBody
    };
    this.experienceApi.addExperience(experienceFormBody).subscribe(response => {
      this.notifier.success('Experience Added Successfully');
      this.router.navigate(['/experiences/list']);
    }, error => {
      this.notifier.error(error.error.userMessage);
    });
  }

  private performEditOperation(experienceFormBody, experienceId) {
    this.experienceApi.updateExperience(experienceFormBody, experienceId).subscribe(response => {
      this.notifier.success('Experience Editted Successfully');
      this.router.navigate(['/experiences/list']);
    }, error => {
      this.notifier.error(error.error.userMessage);
    });
  }

}
export class AttachedFileModel {
  id: string;
  name: string;
  type: string;
  /**
   *
   */
  constructor() {
    this.id = '';
    this.name = '';
    this.type = '';
  }
}
